window.addEventListener('load', event => {
    let blurVal = 0;
    let opacityVal = 1;
    let topValue = 1;
    let scrolledY = window.scrollY;
    let blurTarget = document.querySelector('.scroll-blur-target');

    if (blurTarget) {
        const intersectionChanged = function (entry) {
            if (entry.isIntersecting) {
                document.addEventListener('scroll', throttleScroll, {passive: true})
            } else {
                document.removeEventListener('scroll', throttleScroll);
            }
        };

        const callback = (entries, observer) => {
            entries.forEach(intersectionChanged);
        };

        const options = {
            threshold: 0.1
        };

        const observer = new IntersectionObserver(callback, options);
        observer.observe(blurTarget);

        let throttleScroll =  _throttle(heroScrollBlur, 16, {leading: true, trailing: true});

        heroScrollBlur(true);

        const setBlurOnLoad = setTimeout(throttleScroll, 50);

        function heroScrollBlur(onLoad) {
            let scrollTop = window.scrollY;
            if ((scrollTop != scrolledY) || (onLoad === true)) {
                scrolledY = window.scrollY;
                let homeHeaderPanel = document.querySelector('.header-panel');
                let panelHeight = homeHeaderPanel.offsetHeight;
                let panelTop = homeHeaderPanel.getBoundingClientRect().top;
                let panelHeightScrolledPercent = Math.round(panelTop / panelHeight * -100);

                topValue = Math.round(scrollTop / 5) + 'px';
                blurTarget.style.top = topValue;

                if (panelTop < 0) {
                    blurVal = Math.round(panelHeightScrolledPercent / 4);
                    opacityVal = Math.round(100 - panelHeightScrolledPercent) / 100 ;

                    blurTarget.style.filter = `blur(${blurVal}px)`;
                    blurTarget.style.opacity = opacityVal;
                }
                else {
                    opacityVal = 1;
                    blurVal = 0;
                    blurTarget.style.opacity = opacityVal;
                    blurTarget.style.filter = `blur(${blurVal})`;
                }
            } else {
                return;
            }

        }
    }
});